import type { Settlement } from '../../engine/settlement';
import { getFoodPerPersonPerHour, getHouseOccupants } from '../../engine/settlement';
import type { GameConfig } from '../../config/gameConfig';

// TODO: it should return targets PER house, and each house could be different number of people in it so different target
export function buildFoodTargets(settlement: Settlement, config: GameConfig): number[] {
    const occupants = getHouseOccupants(settlement);
    const foodPerHour = getFoodPerPersonPerHour(config);
    return occupants.map((count) =>
        Math.ceil(count * settlement.production.population.houseFoodTargetHours * foodPerHour),
    );
}

export function moveToHouse(
    settlement: Settlement,
    resource: 'food' | 'wood' | 'charcoal',
    amount: number,
    targets?: number[],
): number {
    if (!settlement.houses || settlement.houses.length === 0) return 0;
    let remaining = amount;
    while (remaining > 0) {
        let index = -1;
        let bestNeed = Number.NEGATIVE_INFINITY;
        let minValue = Number.POSITIVE_INFINITY;
        for (let i = 0; i < settlement.houses.length; i += 1) {
            const target = targets ? targets[i] : Number.POSITIVE_INFINITY;
            const value = settlement.houses[i].storage[resource];
            if (!targets) {
                if (value < minValue) {
                    minValue = value;
                    index = i;
                }
                continue;
            }
            const need = target - value;
            if (need <= 0) continue;
            if (need > bestNeed) {
                bestNeed = need;
                index = i;
            }
        }
        if (index < 0) break;
        settlement.houses[index].storage[resource] += 1;
        remaining -= 1;
    }
    return amount - remaining;
}

function getHouseHeatUnits(settlement: Settlement, index: number, config: GameConfig): number {
    const house = settlement.houses[index];
    return (
        house.storage.wood * config.heat.warmth.wood +
        house.storage.charcoal * config.heat.warmth.charcoal
    );
}

export function moveHeatToHouse(
    settlement: Settlement,
    resource: 'wood' | 'charcoal',
    amount: number,
    heatTargets: number[],
    config: GameConfig,
): number {
    if (!settlement.houses || settlement.houses.length === 0) return 0;
    let remaining = amount;
    while (remaining > 0) {
        let index = -1;
        let bestNeed = 0;
        for (let i = 0; i < settlement.houses.length; i += 1) {
            const target = heatTargets[i] ?? 0;
            const current = getHouseHeatUnits(settlement, i, config);
            const need = target - current;
            if (need <= 0) continue;
            if (need > bestNeed) {
                bestNeed = need;
                index = i;
            }
        }
        if (index < 0) break;
        settlement.houses[index].storage[resource] += 1;
        remaining -= 1;
    }
    return amount - remaining;
}
